/* eslint-disable @typescript-eslint/no-explicit-any */
import { WidgetData } from 'src/store/actions/widget';

export const mapClientSettings = (payload: any): WidgetData | null => {
	if (!payload || !payload.id) return null;
	return {
		id: payload.id,
		domain: payload.domain,
		image: payload.image,
		thumbnail: payload.thumbnail,
		bot: payload.bot,
		botWidget: payload.bot_widget ?? undefined,
		language: payload.language,
		text: payload.text,
		position: payload.position,
		multilingual: payload.multilingual ?? undefined,
		name: payload.name ?? undefined,
		metaTitle: payload.meta_title ?? undefined,
		metaDescription: payload.meta_description ?? undefined,
		metaKeywords: payload.meta_keywords ?? undefined,
		ogImageUrl: payload.og_image_url ?? undefined,
		faviconUrl: payload.favicon_url ?? undefined,
		themeColor: payload.theme_color ?? undefined,
		canonicalUrl: payload.canonical_url ?? undefined,
		publisherUrl: payload.publisher_url ?? undefined,
		gtmId: payload.gtm_id ?? undefined,
		ga4Id: payload.ga4_id ?? undefined,
		texts: payload.texts ?? undefined,
		initialQuestions: payload.initial_questions ?? undefined
	};
};
